export default __webpack_public_path__ + "static/media/opensea.bb5ecc8e.svg";